import React, { useState } from 'react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { Tr, Td } from 'react-super-responsive-table';
import DatePicker from '../datepicker/datepicker';
import CurrencyInput from '../currencyinput/currencyinput';
import { StoreContext } from '../../utils/store';
import IconButton from '../button/iconbutton';

// eslint-disable-next-line no-unused-vars
import { installmentcss } from './installment.css';

function Installment(props) {
  const {
    id,
    date,
    amount,
    removeCallback,
    updateInstallmentCallback,
    dateErrorMessage,
    amountErrorMessage,
    sort,
    finalDate,
  } = { ...props };
  const [ID] = useState(id);
  const [DATE, setDate] = useState(date);
  const [AMOUNT, setAmount] = useState(amount);

  const {
    incurredDate: [minDate],
  } = React.useContext(StoreContext);

  // const maxDate = new Date();

  const handleRemove = () => {
    removeCallback(ID);
  };

  const handleChangeAmount = v => {
    setAmount(v);
    updateInstallmentCallback({
      id: ID,
      date: DATE,
      amount: v,
      key: ID,
      dateErrorMessage,
      amountErrorMessage: undefined,
      sort,
    });
  };

  const handleChangeDate = d => {
    setDate(d);
    updateInstallmentCallback({
      id: ID,
      date: d,
      amount: AMOUNT,
      key: ID,
      dateErrorMessage: undefined,
      amountErrorMessage,
      sort,
    });
  };

  // const showErrors = () => {
  //   if (dateErrorMessage || amountErrorMessage) {
  //     return (
  //       <Tr>
  //         <Td>
  //           <span className="error">{dateErrorMessage}</span>
  //         </Td>
  //         <Td>
  //           <span className="error">{amountErrorMessage}</span>
  //         </Td>
  //       </Tr>
  //     );
  //   }
  //   return null;
  // };

  return (
    <>
      <Tr>
        <Td>
          <DatePicker
            className={
              dateErrorMessage || amountErrorMessage ? '' : 'hide-errors'
            }
            date={DATE}
            minDate={minDate}
            maxDate={finalDate}
            errorMessage={dateErrorMessage}
            onDateChange={handleChangeDate}
            labelledby="installment-date-title"
          />
        </Td>
        <Td>
          <CurrencyInput
            className={
              dateErrorMessage || amountErrorMessage ? '' : 'hide-errors'
            }
            value={AMOUNT}
            onValueChange={handleChangeAmount}
            errorMessage={amountErrorMessage}
            label="installment-amount-title"
          />
        </Td>
        <Td
          className={
            dateErrorMessage || amountErrorMessage
              ? 'remove-installment-container error'
              : 'remove-installment-container'
          }
        >
          <IconButton
            icon={FaRegTrashAlt}
            onClick={handleRemove}
            className="remove"
            title="remove"
            iconOnly
          />
        </Td>
      </Tr>
    </>
  );
}

export default Installment;
